import { Trans } from '@lingui/react'
import classnames from 'clsx'
import type { VFC } from 'react'

import { TENANT_COM, TYPE_CART_BOTTOM, TYPE_CART_TOP } from 'shared/consts'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

type Props = {
  shippingPrice: string
  wid: number
}
const ProductSliderItemShippingPrice: VFC<Props> = ({ shippingPrice, wid }) => {
  const { tenant, crosssell } = usePublicConfig()

  const isCartCsw =
    crosssell?.widgets?.[TYPE_CART_BOTTOM] === wid ||
    crosssell?.widgets?.[TYPE_CART_TOP] === wid

  if (!isCartCsw || tenant !== TENANT_COM) {
    return null
  }
  const priceAsNumber = parseFloat(
    String(shippingPrice).replace(',', '.')
  ).toFixed(2)
  const priceFormatted = `€ ${priceAsNumber.replace('.', ',')}`

  const isShippingPriceFree = shippingPrice === '0,00'

  return (
    <div className="xsellShippingPrice u-text-align--center">
      <div
        className={classnames('u-padding-small--top a-p8', {
          'u-color--positive': isShippingPriceFree,
          'u-color--grey': !isShippingPriceFree,
        })}
      >
        {isShippingPriceFree ? (
          <Trans id="general.label.now.freeShipping" />
        ) : (
          <Trans
            id="general.label.additionalShippingCost"
            values={{ amount: priceFormatted }}
          />
        )}
      </div>
    </div>
  )
}

export default ProductSliderItemShippingPrice
